import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ShowButton,
  FunctionField,
  ChipField,
} from 'react-admin'

import { FaGoogle } from 'react-icons/fa'
import { MdVerified } from 'react-icons/md'

const UserList = (props) => {
  return (
    <List {...props}>
      <Datagrid>
        {/* <TextField source='name' />
        <TextField source='email' /> */}
        <FunctionField
          label='user'
          render={(record) => (
            <>
              <div>
                <b>{record.name}</b>
              </div>
              <div>
                {record.email}
                {record.emailVerifiedAt && <MdVerified />}
                {record.googleId && <FaGoogle color='#ea4335' />}{' '}
              </div>
            </>
          )}
        />

        <FunctionField
          render={(record) => (
            <ChipField
              source='role'
              color={record.role == 'regular' ? 'default' : 'primary'}
            />
          )}
        />
        <DateField source='lastSignin' />
        <DateField source='createdAt' />

        <ShowButton basePath='/users' />
        <EditButton basePath='/users' />
      </Datagrid>
    </List>
  )
}

export default UserList
